import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';

import { DataField as DataFieldType } from '../types';
import {
  FLYOUT_FIELD_TITLE_FONT_SIZE,
  FLYOUT_FIELD_TITLE_FONT_WEIGHT,
  FLYOUT_FIELD_VALUE_FONT_SIZE,
  FLYOUT_FIELD_VALUE_FONT_WEIGHT,
  FLYOUT_FIELD_VALUE_LINE_HEIGHT,
} from '../constants';

import { InfoTooltipDrawer } from '@/components/InfoTooltipDrawer';

export interface DataFieldProps extends Omit<DataFieldType, 'value'> {
  value: DataFieldType['value'];
}

const DataField: React.FC<DataFieldProps> = ({
  title,
  value,
  tooltip,
  isEditable,
  onClick,
  editContent,
}) => {
  return (
    <Box
      sx={(theme) => ({
        width: '33.33%',
        p: 1,
        [theme.breakpoints.down(801)]: {
          width: '50%',
        },
      })}
    >
      {title && (
        <Typography
          fontSize={FLYOUT_FIELD_TITLE_FONT_SIZE}
          fontWeight={FLYOUT_FIELD_TITLE_FONT_WEIGHT}
        >
          {title}
          {tooltip && (
            <InfoTooltipDrawer
              content={tooltip}
              title={title}
            />
          )}
        </Typography>
      )}

      {Array.isArray(value) ? (
        value.map((v, i) => (
          <Box
            key={i}
            sx={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Typography
              fontSize={FLYOUT_FIELD_VALUE_FONT_SIZE}
              fontWeight={FLYOUT_FIELD_VALUE_FONT_WEIGHT}
              lineHeight={FLYOUT_FIELD_VALUE_LINE_HEIGHT}
            >
              {v.label}
            </Typography>
            <Typography
              fontSize={FLYOUT_FIELD_VALUE_FONT_SIZE}
              fontWeight={FLYOUT_FIELD_VALUE_FONT_WEIGHT}
              lineHeight={FLYOUT_FIELD_VALUE_LINE_HEIGHT}
            >
              {v.value}
            </Typography>
          </Box>
        ))
      ) : value ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            fontSize={FLYOUT_FIELD_VALUE_FONT_SIZE}
            fontWeight={FLYOUT_FIELD_VALUE_FONT_WEIGHT}
            lineHeight={FLYOUT_FIELD_VALUE_LINE_HEIGHT}
            sx={
              onClick && !isEditable
                ? {
                    cursor: 'pointer',
                    '&:hover': { textDecoration: 'underline' },
                  }
                : {}
            }
            onClick={onClick && !isEditable ? onClick : undefined}
          >
            {value}
          </Typography>
          {isEditable && editContent && (
            <IconButton
              onClick={onClick}
              sx={{ p: 0.5 }}
            >
              {editContent}
            </IconButton>
          )}
        </Box>
      ) : null}
    </Box>
  );
};

export default React.memo(DataField);
